import { useTranslation } from 'react-i18next';
import SectionTitle from '@/components/base/SectionTitle';
import ComicCard from '@/components/base/ComicCard';
import { hotWorks } from '@/mocks/homeData';

export default function HotWorksGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20">
      <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
        <SectionTitle
          title={t('home.hotWorks.title')}
          subtitle={t('home.hotWorks.subtitle')}
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotWorks.map((comic, idx) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              cover={comic.cover}
              rating={comic.rating}
              reads={comic.reads}
              status={comic.status}
              genres={comic.genres}
              updateDay={comic.updateDay}
              featured={idx === 0}
            />
          ))}
        </div>
      </div>
    </section>
  );
}